<template>
  <div class="purchase-pod-countdown">
    <Countdown :variant="variant" :theme="theme" :endDate="endDate" />

    <h3 class="purchase-pod-countdown__title">{{ countdownTitle }}</h3>
    <p class="purchase-pod-countdown__text">{{ countdownText }}</p>
  </div>
</template>

<script>
import Countdown, { VARIANTS, THEMES } from '@/components/_shared/Countdown.vue'
export { VARIANTS, THEMES }

export default {
  name: 'PurchasePodCountdown',
  components: {
    Countdown,
  },
  props: {
    endDate: {
      type: String,
      required: true,
    },
    hasCountdownEnded: {
      type: Boolean,
      required: true,
    },
    variant: {
      type: String,
    },
    theme: {
      type: String,
    },
    productName: {
      type: String,
    },
  },

  computed: {
    countdownTitle() {
      return this.hasCountdownEnded
        ? this.$t('pdp.purchase_pod.raffle_countdown_ended.title')
        : this.$t('pdp.purchase_pod.raffle_countdown.title')
    },

    countdownText() {
      return this.hasCountdownEnded
        ? this.$t('pdp.purchase_pod.raffle_countdown_ended.text')
        : this.$t('pdp.purchase_pod.raffle_countdown.text', { product_name: this.productName })
    },
  },
}
</script>

<style lang="scss" scoped>
.purchase-pod-countdown {
  text-align: center;

  &__title {
    color: $color-white;
    margin-top: 28px;
  }

  &__text {
    font-size: $font-size-small;
    color: $color-grey-mid-1;
    line-height: 1.6;
  }
}
</style>
